import React from 'react';
import PropTypes from 'prop-types';
import CostObjsGrid from 'shared/components/costObjsGrid/CostObjsGrid';
import { pageBackgroundGray } from 'theme/mainColors';
import { COST_OBJ_PROP_TYPE } from 'shared/constants/PropTypes';

class CostObjsOperations extends React.PureComponent {
  state = {
    perPage: 10,
    page: 0
  };

  componentWillMount() {
    this.props.costObjsActions.fetchCostObjs(0, 10);
  }

  handlePageChange = (page, perPage) => {
    this.props.costObjsActions.fetchCostObjs(page, perPage);
    this.setState({ perPage, page });
  };

  handleDeleteCostObj = costObjId => {
    const { page, perPage } = this.state;
    this.props.costObjsActions.deleteCostObj(costObjId, page, perPage);
  };

  handleEditCostObj = costObjId => this.props.costObjsActions.fetchCostObj(costObjId);

  handleCloseDeleteFailed = () => this.props.costObjsActions.resetDeleteFailed();

  render() {
    const { costObjs, totalEntries, fetchingCostObjs, errorMessage } = this.props;
    return (
      <div className="cost-objs-operations__main-container">
        <CostObjsGrid
          costObjsListGridData={ costObjs }
          showPagination={ true }
          onPageChange={ this.handlePageChange }
          totalItems={ totalEntries }
          fetchingCostObjs={ fetchingCostObjs }
          backgroundColor={ pageBackgroundGray }
          showMoreActionsIcon={ true }
          onDeleteCostObj={ this.handleDeleteCostObj }
          onEditCostObj={ this.handleEditCostObj }
          onCloseDeleteFailed={ this.handleCloseDeleteFailed }
          errorMessage={ errorMessage }
        />
      </div>
    );
  }
}

CostObjsOperations.propTypes = {
  costObjs: PropTypes.arrayOf(COST_OBJ_PROP_TYPE),
  totalEntries: PropTypes.number.isRequired,
  fetchingCostObjs: PropTypes.bool.isRequired,
  costObjsActions: PropTypes.shape({
    fetchCostObjs: PropTypes.func,
    deleteCostObj: PropTypes.func,
    fetchCostObj: PropTypes.func,
    resetDeleteFailed: PropTypes.func
  }).isRequired,
  errorMessage: PropTypes.string
};

export default CostObjsOperations;



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjsOperations/CostObjsOperations.js